<template>
    <div id="qsn">
        <div animated fadeDown class="header">
            <h2>
                Nous nous engageons à fournir des soins attentifs et personnalisés,
                visant à assurer la réhabilitation totale de nos patients.
            </h2>
        </div>
        <div animated fadeUp class="qsn">
            <div class="content">
                <h1>Qui sommes nous ?</h1>
                <p>
                    FAL.Care Santé Mentale est une organisation d'aide et de soins à domicile spécialisée en psychiatrie. <br>
                    Reconnue par les assurances maladie, elle vise la réhabilitation des patients souffrant de troubles psychiques par l'adoption d'un modèle de psychiatrie intégrée et communautaire. Elle met en œuvre les politiques publiques de promotion et de prévention de la santé mentale.
                </p>
                <p>
                    Chez FAL.Care Santé Mentale, le personnel soignant dispense, sur prescription médicale, les prestations de 
                    soins reconnues au sens de l'Ordonnance sur les Prestations de l'Assurance pour les Soins (OPAS)
                </p>
            </div>
            <img src="@/assets/background/region.jpg" alt="">
        </div>
        <img animated fade src="@/assets/emote/emoticon_b.svg" alt="" class="emo">

    </div>
    <div class="collaborateur">
        <h1><span class="ssub">Fondateur</span> et directeur de l'organisation</h1>
        <div animated fade class="principal">
            <img src="@/assets/collaborator/fondateur.jpg" alt="">
            <div class="prin_content">
                <h2>Khaled <br> Falfoul</h2>
                <p class="subtitle">Clinicien spécialisé en santé mentale</p>
                <p class="justify">
                    Titulaire d’un Master en Sciences et bénéficiant de plus de 10 ans d’expérience en psychiatrie hospitalière et ambulatoire, j’ai acquis une expertise approfondie dans la prise en charge des troubles émotionnels et comportementaux. 
                    Différentes approches thérapeutiques sont proposées, notamment le biofeedback, la thérapie par la réalité virtuelle (TRV) ainsi que l’hypnose ericksonienne thérapeutique.
                </p>
            </div>
        </div>
        <h1><span class="ssub">Responsables de site</span></h1>
        <div animated scaleUp class="colaborateur_">
            <CardCollaborator v-for="collaborateur in resSite" :name="collaborateur.name" :surname="collaborateur.surname" :desc="collaborateur.desc" :key="collaborateur.name"/>
        </div>
        <h1><span class="ssub">Secrétariat</span></h1>
        <div animated scaleUp class="colaborateur_">
            <CardCollaborator v-for="collaborateur in secretaires" :name="collaborateur.name" :surname="collaborateur.surname" :desc="collaborateur.desc" :key="collaborateur.name"/>
        </div>
        <h1><span class="ssub">Infirmier·ères</span></h1>
        <div animated scaleUp class="colaborateur_">
            <CardCollaborator v-for="collaborateur in infs" :name="collaborateur.name" :surname="collaborateur.surname" :desc="collaborateur.desc" :key="collaborateur.name"/>
        </div>
        <h1><span class="ssub">ASSC / Aides-soignantes / Educatrice</span></h1>
        <div animated scaleUp class="colaborateur_">
            <CardCollaborator v-for="collaborateur in as" :name="collaborateur.name" :surname="collaborateur.surname" :desc="collaborateur.desc" :key="collaborateur.name"/>
        </div>
    </div>
    <div class="questions_container">
        <h1>Questions fréquentes</h1>
        <div animated fade class="questions">
            <questionsLine v-for="question in questions" :question="question.question" :response="question.response" :key="question.question"/>
        </div>
    </div>
</template>

<script>
    import CardCollaborator from './cardCollaborator.vue'
    import questionsLine from './questionsLine.vue';

    export default {
        name: 'QsnAccueil',
        data() {
            return {

                resSite : [
            

                    {

                    name: "Eljesa",
                    surname: "Sadiki",
                    desc: `
                        Infirmière HES diplômée en 2009 avec 15 ans d’expérience en psychiatrie, j’ai obtenu un CAS de praticienne formatrice en 2014 et un CAS en Mindfulness en 2020. J'ai travaillé au Centre Neuchâtelois de Psychiatrie, notamment dans les unités des troubles borderline aux admissions crise et aux urgences psychiatriques. 

                        Actuellement responsable des soins dans mon institution, je coordonne les équipes, collabore avec les familles et le réseau professionnel ainsi que les HES-SO santé pour l'encadrement des étudiants infirmiers, et supervise la mise en place de groupes thérapeutiques, notamment en Mindfulness, pour garantir une prise en charge complète et de qualité des patients.
                        `
                    },
                    {
                        name: "Aline",
                        surname: "Dreyfuss",
                        desc: `
                                Je suis infirmière HES, diplômée en 2009. J’ai obtenu un CAS en psychiatrie et santé sociale en 2010 et une formation en psycho-traumatologie centrée compétences en 2022.
                                J’ai travaillé au centre de psychiatrie du nord-vaudois, aux urgences psychiatriques, dans un service ambulatoire de crise puis à l’équipe mobile de transition.
                                J’ai ensuite quitté le nord vaudois pour travailler au centre neuchâtelois de psychiatrie, en ambulatoire puis à l’équipe de transition.
                                Infirmière clinicienne, responsable du site de Neuchâtel.
                        `
                    }
                ],

                secretaires :[
                    {
                        name: "Nour",
                        surname: "Mahmoud",
                        desc: `
                            Titulaire d’un CFC de commerce et d’une maturité professionnelle, j'occupe actuellement le poste de responsable secrétaire et assistante de direction. Mes responsabilités incluent la gestion administrative quotidienne, telle que l’accueil des patients, l’organisation des plannings, le suivi des dossiers et la coordination entre les équipes médicales et les patients, tout en veillant au respect strict de la confidentialité.

                            En parallèle, je suis en charge du marketing digital, notamment de la création de contenu, de l’animation et de la stratégie des réseaux sociaux, dans le but de renforcer la visibilité de l’organisation.

                            Rigoureuse, autonome et dotée d’une grande capacité d’adaptation, je mets à profit mes compétences en gestion et en communication pour optimiser les processus internes et contribuer à la croissance de l’entreprise.
                            `
                    },
                ],
                infs :[
                    {
                        name: "Emmy",
                        surname: "Totel",
                        desc: `Infirmière en psychiatrie depuis 2018, j’ai obtenu mon diplôme d’état en France. J’ai travaillé pendant 2ans dans le milieu hospitalier de la psychiatrie auprès des jeunes adultes, adultes et personnes âgées dans la région parisienne. J’ai ensuite décidé de venir travailler au CNP auprès des personnes adultes en hospitalier à Préfargier, puis aux urgences psychiatriques pendant 3ans. En tant qu’infirmière en ambulatoire, j’accompagne les patients avec bienveillance tout au long de leur parcours de soins. Je suis à l’écoute de leurs besoins, j’évalue leur état de santé, et je les soutiens dans leur quotidien. Mon rôle, c’est aussi de créer un lien de confiance, d’aider à prévenir les rechutes et de favoriser leur équilibre et leur autonomie dans la vie de tous les jours.
                                `
                    },
                    {
                        name: "Océane",
                        surname: "Mareschal",
                        desc: `
                                Je suis infirmière en psychiatrie diplômée depuis 2019. Avec une expérience variée en intérim dans la santé mentale, j'ai eu l'opportunité de travailler avec différents publics, des adolescents aux personnes âgées, dans de multiples services.

                                Ma passion pour l'art-thérapie m'a conduit à intégrer la musique, le dessin et le théâtre dans mon travail. Je suis convaincue que l'art peut être un outil puissant pour favoriser la guérison, la croissance personnelle et le bien-être.

                                Mon objectif est de créer un espace sûr et accueillant où les personnes peuvent exprimer leurs émotions, explorer leurs pensées et développer leur potentiel.
                            `
                    },
                    {
                        name: "Eva",
                        surname: "Quesada",
                        desc: `
                                Infirmière HES diplômée en 2025, j’ai acquis mon expérience tout au long de mes études, notamment en unité de crise en psychiatrie hospitalière, aux urgences, en soins ambulatoires et à domicile en santé mentale, avec un suivi particulièrement adapté aux situations chroniques. En parallèle, j’ai travaillé pendant deux ans en soins palliatifs gériatriques, où j’ai appris à apporter un soutien attentif et respectueux aux personnes en fin de vie.
                                Ces expériences m’ont permis de développer une approche globale, où l’accompagnement personnalisé, le soutien émotionnel et la création d’une relation de confiance authentique sont au cœur de mon approche. Je m’engage à offrir à mes patients un espace sécurisant, où ils peuvent évoluer à leur rythme, trouver un soutien solide et renforcer leur estime de soi dans un environnement bienveillant.
                            `
                    },
                    {
                        name: "Cédric",
                        surname: "Prétat",
                        desc: `
                            Infirmier HES diplômé en 2020 de la HES de Fribourg, j'ai débuté ma pratique au Pôle Santé Mental à Bellelay, dans un service hospitalier de crise pour adultes. Par la suite, j'ai travaillé pendant un an au CNP à Préfargier, puis près de deux ans au Centre d'Urgences Psychiatriques (CUP). Ces expériences m'ont permis d'accompagner des patients confrontés à des troubles psychiques aigus et de gérer des situations de crise. En 2024, j'ai choisi de m'orienter vers des prises en charge psychiatriques ambulatoires, où mon rôle consiste principalement à accompagner et soutenir les patients dans leur environnement. Je suis également responsable des groupes thérapeutiques de musicothérapie.

                            `
                    },
                    {
                        name: "Lucie",
                        surname: "Court",
                        desc: `
                            Titulaire du diplôme d'état infirmier depuis 2013, ma trajectoire professionnelle s'est naturellement orientée vers la santé mentale. Ma carrière a débuté en milieu hospitalier puis cette expérience m’a menée à travailler dans un Foyer dispensant des soins psychiatriques. J’ai ainsi pu acquérir une solide expérience et développé des compétences variées.
                            Ce consensus a suscité mon intérêt pour les soins psychiatriques ambulatoire ou je propose un accompagnement dans un espace sécurisant, bienveillant et sans jugement.
                            Mon approche est collaborative et avec une vision profondément humaine du soin : je valorise les ressources, l'histoire et les forces de chaque personne.
                            J'accorde une importance particulière à la prévention, à la compréhension de soi et aux outils concrets qui renforcent l'autonomie émotionnelle.
                            Mon engagement est d'accompagner avec présence, écoute, respect et authenticité, en alliant mon expertise clinique.
                            `
                    },

                ],
                as:[
                    {
                        name: "Carole",
                        surname: "Barbalat",
                        desc: `
                            Carole est une professionnelle formée et diplômée de la Croix-Rouge en tant qu'auxiliaire de vie. 
                            Dans le cadre de son rôle d'aide à domicile, elle apporte une assistance essentielle à ses patientes en leur offrant un soutien au quotidien. 
                            Son travail consiste à accompagner les personnes fragiles ou âgées, en les aidant dans 
                            les soins d’hygiène, ainsi que dans la gestion de leurs déplacements. Grâce à sa formation spécialisée, Carole sait répondre avec 
                            bienveillance et professionnalisme aux besoins de ses patientes, en leur offrant une écoute attentive et un soutien adapté à leurs conditions de vie. 
                            Elle veille à leur bien-être physique et émotionnel, tout en assurant un environnement sécurisant et chaleureux à domicile.
                            `
                    },
                    {
                        name: "Atika",
                        surname: "Basri",
                        desc: `Atika possède plus de 15 ans d’expérience dans le domaine de l’aide à domicile. Elle joue un rôle clé auprès des personnes âgées ou en situation de fragilité, en leur apportant un accompagnement quotidien essentiel. Son travail consiste notamment à les assister dans les soins d’hygiène et à faciliter leurs déplacements. Grâce à son expertise, Atika répond avec bienveillance, écoute et professionnalisme aux besoins spécifiques de chaque personne. Elle veille attentivement à leur bien-être, tant physique qu’émotionnel, en leur offrant un cadre de vie sécurisant, chaleureux et respectueux de leur dignité.
                                `
                    },
                   {
                        name: "Justine",
                        surname: "Gosatti",
                        desc: ` Je suis une aide-soignante diplômée depuis 2013 et dispose d’une expérience au sein de plusieurs établissements de soins. J'accorde une importance particulière au bien-être émotionnel et mental des patients, en proposant un accompagnement basé sur l’écoute active, la bienveillance et le respect.

                                J'accompagne les personnes dans leur quotidien (soins, ménage, démarches administratives, rendez-vous), tout en offrant un soutien moral et une présence rassurante, favorisant la confiance et l’expression des besoins. Mon objectif est de contribuer à une prise en charge globale, attentive à la santé physique comme psychique.
                                `
                    }, 
                    {
                        name: "Monica",
                        surname: "Fulconis",
                        desc: `Assistante en soins et santé communautaire, j’accompagne des personnes à domicile et en ambulatoire, portée par un profond engagement d’écoute, de soutien et d’accompagnement. Mon parcours s’est enrichi par l’obtention d’un CAS en prévention et promotion de la santé sexuelle (2024) ainsi que d’un CAS en médiation de conflits (2025), me permettant de soutenir la communication et le rétablissement du lien entre les personnes. Aujourd’hui, je propose des entretiens individuels, de couple et de famille, offrant un espace d’écoute, de soutien et de réflexion, notamment dans les périodes de transition, de tension ou de crise. Mon travail s’articule autour de la communication, de la gestion des émotions et du rétablissement du lien, dans une approche respectueuse du rythme, des besoins et des singularités de chacun. Actuellement en formation en conjugalité et parentalité (certification prévue en 2026), je développe des outils pour accompagner la coparentalité, les difficultés de couple et les dynamiques familiales du quotidien.
                        Je propose des consultations en cabinet ainsi que des accompagnements à domicile, dans une posture bienveillante, attentive et respectueuse de chaque personne.`
                    },
        
                    {
                        name: "Sarah",
                        surname: "Verazzi",
                        desc: `Éducatrice sociale diplômée depuis 2009, j’ai accompagné pendant plusieurs années des enfants et des adolescents en foyer. Cette expérience m’a permis de développer une approche basée sur l’écoute, la bienveillance et le respect du rythme de chacun.  Par la suite, je me suis tournée vers l’insertion sociale, où j’ai soutenu des adultes dans le cadre de suivis individuels ainsi que dans l’animation de groupes, notamment autour d’un atelier créatif favorisant l’expression, le lien et la valorisation des ressources personnelles. 
                        Désireuse d’orienter aujourd’hui mon accompagnement plus spécifiquement vers les jeunes, les parents et les couples, je suis actuellement en formation en vue de l’obtention d’un CAS en Conjugalités et Parentalités. 
                        Mon approche vise à soutenir l’organisation du quotidien, à redéfinir les rôles de chacun et à renforcer les ressources familiales et sociales.
                        `
                    },
                ],
                collaborateurs: [
                             
                ],
                questions: [
                    {
                        question: "Qui peut bénéficier des prestations fournies par FAL.Care Santé Mentale ?",
                        response: "Toute personne ayant besoin d’aide ou de soins psychiatriques, que ce soit pour cause de maladies psychiatriques, de troubles émotionnels, de troubles phobiques ou de burn-out."
                    },
                    {
                        question: "Quel est l’objectif de la prise en charge chez FAL.Care Santé Mentale ?",
                        response: "Grâce aux prestations d’aide et de soins à domicile, les personnes concernées peuvent continuer à vivre dans leur environnement familier en dépit de leurs difficultés. Il est également possible de les réintégrer plus rapidement à leur domicile à la suite d'une hospitalisation. Les prestations ont pour objectif principal de maintenir et de stimuler l’autonomie à domicile."
                    },
                    {
                        question: "Pourquoi choisir FAL.Care Santé Mentale comme prestataire de soin ?",
                        response: "Les prestations dispensées sont adaptées aux besoins réels des patients et prennent en compte leur entourage et leur environnement social. De plus, la prise en charge à domicile coûte moins cher à la collectivité qu'un placement en institution."
                    }
                ]
            }
        },
        methods: {
            //
        },
        components: {
            CardCollaborator,
            questionsLine
        }
    }
</script>

<style scoped>

div.header{
    background: #7CBD8A;
    text-align: center;
    color: var(--white);
    padding-top: 5em;
    padding-bottom: 10em;
}

div.header h2{
    font-size: 1.2em;
    width: 45%;
    margin: auto;
}

div.qsn{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 3vh;
    background-color: #49584C;
    padding: 5em;
    width: 90%;
    margin: auto;
    border-radius: 10px;
    transform: translateY(-5em);
    position: relative;
}

/* children of qsm 50% */
div.qsn div.content{
    width: 50%;
    text-align: left;
    height: 100%;
    display: flex;
    justify-content: center;
}

div.qsn div.content h1{
   text-align: left;
   width: 100%;
}

div.qsn div.content p{
    text-align: left;
    font-family: "Archia", sans-serif;
}

div.qsn img{
    width: 50%;
    border-radius: 10px;
}

img.emo{
    width: 10%;
    position: absolute;
    left: 5%;
    bottom: 5em;
    transform: translate(-30%, 30%);
    z-index: -1;
}

div#qsn {
  color: var(--white);
  width: 100%;
  position: relative;
}

div#qsn > h1 {
    text-align: center;
    margin-bottom: 7vh;
    position: relative;
}

div#qsn > div.wrapper > div{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    column-gap: 3vh;
    align-items: stretch;
    margin-bottom: 5vh;
    min-height: 184px;
}

div#qsn > div.wrapper div:nth-child(odd){
    padding-left: 8vh;
}

div#qsn > div.wrapper div:nth-child(even){
    padding-right: 8vh;
    flex-direction: row-reverse;
}

div#qsn > div.wrapper  div  .text-part{
    width: calc(80% - 4vh - 3vh/2);
}

div#qsn > div.wrapper  div  img{
    width: calc(20% - 4vh - 3vh/2);
}

/* think line under text */
span.ssub{
    position: relative;
    padding-left: 4px;
    font-weight: larger;
}
span.ssub::after {
    content: "";
    width: 100%;
    display: inline-block;
    position: absolute;
    height: 30%;
    background: #A8D3B1;
    left : 0;
    bottom: 0;
    z-index: -1;
}

div.collaborateur{
    width: 60%;
}

div.collaborateur div.principal{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    column-gap: 3vh;
    align-items: stretch;
    margin-bottom: 5vh;
    min-height: 184px;
    margin-top: 3em;
}

div.collaborateur div.principal img{
    width: 30%;
    border-radius: 10px;
    filter: grayscale(100%);
    font-weight: 900;
}

div.collaborateur div.principal div.prin_content{
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

div.collaborateur div.principal div.prin_content h2{
    font-size: 3em;
    color: #7CBD8A;
    text-transform: uppercase;
}

div.collaborateur div.principal div.prin_content p{

    font-family: 'Archia';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2em;
    line-height: 29px;
    color: #1E1E2F;
}

div.collaborateur div.principal div.prin_content p.subtitle{
    font-family: 'Sequel Sans';
    font-style: normal;
    font-weight: 420;
    font-size: 1em;
    line-height: 24px;
    color: #000000;
}

div.colaborateur_{
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    padding: 0.5em;
    margin-top: 4em;
}

div.questions_container{
    width: 100%;
    background: #49584C;
    padding: 5em 0;
    color: var(--white);
    transition: height 0.5s ease-in-out;
    margin-top: 5em;
}

div.questions{
    width: 60%;
    margin: auto;
}

div.questions_container h1{
    width: 60%;
    text-align: left;
    position: relative;
    margin: auto;
}

@media only screen and (max-device-width: 600px ){
    div#qsn > div.wrapper div:nth-child(odd){
        padding-left: 0vh;
    }
    
    div#qsn > div.wrapper div:nth-child(even){
        padding-right: 0vh;
    }
    div#qsn > div.wrapper  div  .text-part{
        width: 100%;
    }

    div#qsn > div.wrapper > div{
        display:block;
    }

    div#qsn > div.wrapper  div  img{
        float: right;
        width: 30%;
    }

    div#qsn > div.wrapper  div  .text-part{
        font-size: small;
    }

    div#qsn > div.wrapper  div  .text-part h2{
        font-size: 1.5em;
    }
    div.collaborateur {
        width: 100%;
    }

    div.header h2{
        font-size: 1em;
        width: 90%;
    }

    div.qsn{
        display: flex;
        flex-direction: column;
        padding: 0;
    }

    div.qsn div.content{
        width: 100%;
        text-align: center;
        height: 100%;
        display: flex;
        justify-content: center;
        padding: 0.5em;
    }

    div.qsn div.content h1{
        text-align: center;
        width: 100%;
        font-size: 1.8em;
    }

    div.qsn img{
        width: 100%;
        border-radius: 10px;
        padding: 0.5em;
    }

    div.collaborateur div.principal{
        flex-direction: column;
    }

    img.emo{
        width: 20%;
        left: 8%;
    }
    div.collaborateur div.principal div.prin_content{
        width: 100%;
        padding: 0.5em;
        justify-content: center;
        align-items: center;
    }

    div.collaborateur div.principal div.prin_content p {
        padding: 0.5em;
        text-align: center;
    }

    div.collaborateur h1{
        font-size: 2em;
        padding: 0.5em;
    }

    div.collaborateur div.principal img{
        width: 70%;
        margin: auto;

    }

    div.questions{
        width: 100%;
        padding: 0.5em; 
    }

    div.questions_container h1{
        width: 100%;
        text-align: center;
        padding: 0.5em;
    }
}
</style>